import JumpScene2 from "./JumpScene2";
import JumpScene3 from "./JumpScene3";
import ForestParcours from "./ForestPacours";
import MazeCastle from "./MazeCastle";
import DreamEscape from "./DreamEscape";
import JourneyToDonut from "./JourneyToDonut";
import Runnerz from "./Runnerz";
import Techlympic from "./Techlympic/View";
import Runnerz2024 from "./Runnerz2024";
import SeoulDigitechgo from "./SeoulDigitechgo";

const queryParams = new URLSearchParams(window.location.search);
const runMode = queryParams.get("mode");

export default function RedbrickEventContents({redbrickEventProjectKey}) {
  return (
    <>
      {runMode === "play" && redbrickEventProjectKey === "JUMP_SCENE_2" && <JumpScene2 />}
      {runMode === "play" && redbrickEventProjectKey === "JUMP_SCENE_3" && <JumpScene3 />}
      {runMode === "play" && redbrickEventProjectKey === "FOREST_PARCOURS" && <ForestParcours />}
      {runMode === "play" && redbrickEventProjectKey === "MAZE_CASTLE" && <MazeCastle />}
      {runMode === "play" && redbrickEventProjectKey === "DREAM_ESCAPE" && <DreamEscape />}
      {runMode === "play" && redbrickEventProjectKey === "DONUT_DRIVE" && <JourneyToDonut />}
      {runMode === "play" && redbrickEventProjectKey === "RUNNERZ" && <Runnerz />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_LOBBY" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_AUDITORIUM" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_MOSTI" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_HALLOFFAME" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_SPONSER" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_CLASS" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "TECHLYMPIC_LOBBY_DEV" && <Techlympic />}
      {runMode === "play" && redbrickEventProjectKey === "RUNNERZ_2024_DEV" && <Runnerz2024 />}
      {runMode === "play" && redbrickEventProjectKey === "RUNNERZ_2024" && <Runnerz2024 />}

      {runMode === "play" &&
        (redbrickEventProjectKey === "DIGITECH_LOBBY" ||
          redbrickEventProjectKey === "DIGITECH_AREANA" ||
          redbrickEventProjectKey === "DIGITECH_AUDITORIUM" ||
          redbrickEventProjectKey === "DIGITECH_CAMPUS" ||
          redbrickEventProjectKey === "DIGITECH_CREATIVELAB" ||
          redbrickEventProjectKey === "DIGITECH_GALLERY") && <SeoulDigitechgo redbrickEventProjectKey={redbrickEventProjectKey} />}
    </>
  );
}
